<template lang="pug">
  h1.text-4xl.font-semibold
    slot
</template>

<script>
export default {
  name: 'PageTitle'
}
</script>
